import React, { 
	useState,
	useContext,
	useCallback
} from "react";
import { 
	IconButton,
	Dialog,
	Typography,
	Box,
	Button
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/PreviewOutlined";
import ImageNotFound from "@mui/icons-material/ImageNotSupportedTwoTone";
import LightTooltip from "../LightTooltip";
import { DataContext } from "../../../App";
import UseFetchData from "../FetchData/FetchData";
import { LoadableContent } from "../LoadableContent/LoadableContent";
import { Link as RouterLink } from "react-router-dom";

export default function ProductModal ({ id }) {

	if (!id) return;

	const context = useContext(DataContext);
	const { status, results, isLoading } = UseFetchData(useCallback(() => context.dataProvider.getProduct(id), [context.dataProvider, id]));

	const [state, setState] = useState({
		isModalVisible: false,
	});

	const onClick = () => {
		setState(previousState => {
			return {
				...previousState,
				isModalVisible: true
			};
		});
	};

	const onClose = () => {
		setState(previousState => {
			return {
				...previousState,
				isModalVisible: false
			};
		});
	};

	const Modal = () => {
		return (
			status &&
				<Dialog
					open={state.isModalVisible}
					onClose={onClose}
					keepMounted
					fullWidth={true}
					maxWidth="sm"
					className="align-content-center"
					
				>
					<LoadableContent isLoading={isLoading} message="Loading Product Preview...">
						{results && results.image_url &&
						<Box sx={{ m: 1 }}>
							<Box sx={{ mb: 2 }}>
								<Typography variant="h6" component="h1" sx={{ fontWeight: "bold" }}>
									{results.name}
								</Typography>
								<Typography variant="h6" component="h2">
									{results.sku}
								</Typography>
							</Box>
							{(results.image_url !== "<nil>") ?
								<Box
									component="img"
									src={results.image_url}
									loading="lazy"
									sx={{ maxWidth: "300px" }}
								/>
								:
								<Box sx={{ mt: 2, mb: 4 }}>
									<ImageNotFound fontSize="large" />
									<Typography variant="body1">
										No Image Found
									</Typography>
								</Box>
							}
							<Box sx={{ m: 1, alignContent: "center" }}>
								<Button 
									variant="contained"
									component={RouterLink} 
									to={`/inventory-detail/${id}`}
								>
									View Product Details
								</Button>
							</Box>
						</Box>}
					</LoadableContent>
				</Dialog>
		);
	};

	return (
		<>
			{
				results.image_url &&
					<>
						<LightTooltip
							title={"Click to preview product"}
							disableHoverListener={false}
							arrow
						>
							<IconButton
								onClick={onClick}
								sx={{ p: 0 }}
							>
								<PreviewIcon fontSize="large" />
							</IconButton>
						</LightTooltip>
						<Modal />
					</>
			}
		</>
	);

}